import React, { useState, useEffect } from "react";
import { getClientEnv } from "../../utils/common";
import { servicePhone } from "../../utils/constants";
/**
 * 当前环境为小鹏app时，点击跳转在线客服页面，否则拨打电话
 * @param props
 * @returns
 */
const ContactService = (props: any) => {
  const UA = navigator.userAgent || "";
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const toServicePage = () => {
    // 跳转在线客服页面
    // 生产: https://xservice.xiaopeng.com/online-client?channel=3
    // 预发: https://xservice.deploy-test.xiaopeng.com/online-client?channel=3
    // 测试: http://xservice.test.xiaopeng.local/online-client?channel=3
    const env = getClientEnv();
    let url = "";
    if (env === "deploy") {
      url = "https://xservice.deploy-test.xiaopeng.com/online-client?channel=3";
    } else if (env === "test") {
      url = "http://xservice.test.xiaopeng.local/online-client?channel=3";
    } else {
      url = "https://xservice.xiaopeng.com/online-client?channel=3";
    }
    window.location.href = url;
  };
  if (isXPApp) {
    return (
      <div
        onClick={toServicePage}
        style={{ textDecoration: "none", color: "#5A960A" }}
      >
        {props.text || props.children}
      </div>
    );
  } else {
    return (
      <div>
        <a
          href={`tel:${servicePhone}`}
          style={{ textDecoration: "none", color: "#5A960A" }}
        >
          {props.text || props.children}
        </a>
      </div>
    );
  }
};

export default ContactService;
